import React from "react";
import { Store, MapPin, Clock, SquareUser } from "lucide-react";
import { CampaignItem } from "./index";
import { ProfileCardBase } from "./profile-card-base";

interface CandidatCardProps {
  item: CampaignItem;
}

export function CandidatCard({ item }: CandidatCardProps) {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N.C.";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatContribution = (contribution?: number) => {
    if (!contribution) return "N.C.";
    return `${Math.round(contribution / 1000)}k€`;
  };

  return (
    <ProfileCardBase
      name={item.name}
      logoUrl={item.avatar_url}
      fallbackIcon={SquareUser}
      profileId={item.id}
      profileType="Profile::Candidat"
      userId={item.user_id}
      entity={item}
      items={[
        {
          icon: Store,
          label: "Apport",
          value: formatContribution(item.project_contribution),
        },
        {
          icon: MapPin,
          label: "Localisation",
          value: item.project_address || "N.C.",
        },
        {
          icon: Clock,
          label: "Inscription",
          value: formatDate(item.updated_at),
        },
      ]}
    />
  );
}
